import React, { useState, useEffect } from 'react';
import '../../styles/reading/LeftSection.css';
import Select from 'react-select';
import { getApiUrl } from '../../utils/apiConfig';

const selectStyles = {
  control: (base, state) => ({
    ...base,
    borderRadius: '10px',
    borderColor: state.isFocused ? '#667eea' : '#764ba2',
    boxShadow: state.isFocused ? '0 4px 16px rgba(102, 126, 234, 0.18)' : '0 2px 8px rgba(102, 126, 234, 0.13)',
    padding: '2px',
    minHeight: '48px',
    fontWeight: 600,
    fontSize: '1.1rem',
    background: 'linear-gradient(90deg, #f8f9fa 60%, #e9eefd 100%)',
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? '#e0e0ff'
      : state.isFocused
      ? '#f3f6ff'
      : '#fff',
    color: state.isSelected ? '#764ba2' : '#222',
    fontWeight: state.isSelected ? 700 : 600,
    fontSize: '1.08rem',
    padding: '16px 18px',
    cursor: 'pointer',
  }),
  menu: (base) => ({
    ...base,
    borderRadius: '10px',
    boxShadow: '0 8px 32px rgba(102, 126, 234, 0.18)',
    zIndex: 20,
  }),
  singleValue: (base) => ({
    ...base,
    color: '#333',
    fontWeight: 700,
  }),
};

const LeftSection = ({ onTopicSelect, onStart }) => {
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [subjectOptions, setSubjectOptions] = useState([]);
  const [topicOptions, setTopicOptions] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMaterials = async () => {
      try {
        const res = await fetch(getApiUrl('reading-materials'));
        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const data = await res.json();
        const grouped = data.materials;

        if (grouped && Object.keys(grouped).length > 0) {
          // Build subject options from API response keys
          const subjects = Object.keys(grouped).map(s => ({ value: s, label: s }));
          setSubjectOptions(subjects);

          // Build topic options from API response
          const topics = {};
          for (const [subject, materials] of Object.entries(grouped)) {
            topics[subject] = materials.map(m => ({
              value: m.id,
              label: m.title,
              url: m.url,
              totalPages: m.total_pages,
            }));
          }
          setTopicOptions(topics);
        }
      } catch (err) {
        console.warn('Failed to fetch reading materials from API:', err.message);
        setSubjectOptions([]);
        setTopicOptions({});
      } finally {
        setLoading(false);
      }
    };

    fetchMaterials();
  }, []);

  const handleStart = () => {
    if (typeof onStart === 'function') onStart();
  };

  return (
    <div className="reading-left-section">
      <div className="subject-dropdown-container">
        <label htmlFor="subject-select" className="subject-label">
          <span role="img" aria-label="subject" style={{ marginRight: '0.5rem', fontSize: '1.2rem' }}>📚</span>
          Select Subject:
        </label>
        <Select
          inputId="subject-select"
          classNamePrefix="react-select"
          options={subjectOptions}
          placeholder="-- Choose a subject --"
          isSearchable={false}
          isLoading={loading}
          value={selectedSubject}
          onChange={option => {
            setSelectedSubject(option);
            setSelectedTopic(null);
          }}
          styles={selectStyles}
        />
      </div>
      {selectedSubject && (
        <div className="subject-dropdown-container">
          <label htmlFor="topic-select" className="subject-label">
            <span role="img" aria-label="topic" style={{ marginRight: '0.5rem', fontSize: '1.2rem' }}>📖</span>
            Select Topic:
          </label>
          <Select
            inputId="topic-select"
            classNamePrefix="react-select"
            options={topicOptions[selectedSubject.value] || []}
            placeholder="-- Choose a topic --"
            isSearchable={false}
            value={selectedTopic}
            onChange={option => {
              setSelectedTopic(option);
              if (onTopicSelect && option && option.url && selectedSubject) {
                onTopicSelect(option.url, selectedSubject, option);
              }
            }}
            styles={selectStyles}
          />
        </div>
      )}
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2.5rem' }}>
        <button className="app-btn" onClick={handleStart} style={{ padding: '1rem 2.5rem', fontSize: '1.2rem', fontWeight: 700, borderRadius: '10px', backgroundColor: '#2C5057', color: '#fff', border: '2px solid #2C5057', boxShadow: '0 2px 8px rgba(75,172,129,0.10)', cursor: 'pointer', letterSpacing: '1px' }}>
          START
        </button>
      </div>
    </div>
  );
};

export default LeftSection;
